export default "__VITE_ASSET__DrR3Asi___"